<script lang="ts">
	let { children, style = undefined } = $props();
	import { page } from '$app/state';
	const theme = $derived(page.data.theme);
</script>

<div class={['white-box', theme]} style={'padding: 0.5em;' + style}>
	{@render children()}
</div>
